import {createGlobalStyle} from 'styled-components';
import Variables from '../../assets/styleVariables';

export const GlobalStyle = createGlobalStyle`
    html,body,#root{
    height: 100%;
    }
    body{
      background-color: ${Variables.colors.complementary};
    }
`;